import React from 'react';
import './SecTitle.css'

const SecTitle = (props) => {
    return ( 
        <div className='SecTitle'>
            <div className='TitleLines'>
                <div className='Line'></div>
                <div className='Line'></div>
            </div>
            <p className='TitleText'>{props.TitleText}</p>
            <div className='TitleLines'>
                <div className='Line'></div>
                <div className='Line'></div>
            </div>
        </div>
     );
}
 
export default SecTitle
